// Shared API client — one place for the base URL, the auth header, and error
// handling. New components should import from here rather than redefining their
// own getToken/apiFetch. (Older files still have local copies; migrate as touched.)
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';

export function getToken() {
  try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; }
  catch { return null; }
}

// Resolves to parsed JSON on success; rejects with the server's error payload
// (or an Error) otherwise, so callers can `try/catch` real failures.
export function apiFetch(path, opts = {}) {
  const token = getToken();
  return fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(token ? { 'x-worker-token': token } : {}), ...opts.headers },
  // A failure rejects with the server's own payload ({ error, code, … }); only when the
  // body isn't JSON does it fall back to a plain Error. (The old chain caught its own
  // rejection and turned every payload into "Request failed (409)", so a server's
  // explanation never reached the screen — Sep 30 2026.)
  }).then(r => r.ok ? r.json() : r.json().catch(() => ({ error: `Request failed (${r.status})`, status: r.status })).then(e => Promise.reject(e && typeof e === 'object' ? { status: r.status, ...e } : new Error(`Request failed (${r.status})`))));
}

// URL for an uploaded file (photos, docs) served from the API host.
export const photoUrl = fn => `${API_BASE.replace('/api', '')}/uploads/${fn}`;
